module.exports = __webpack_public_path__ + "img/locationAdd.e511386f.png";